import React, { useState, useEffect } from 'react';
import CustomSelect from '../customSelect/customSelect';
import { useNavigate, useLocation } from 'react-router-dom';
import apiService from '../../../services/apiService';
import CustomToast from '../../Toast';
import Select from 'react-select';

const EditOrganisationProfile = (orgData) => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [org_name, setOrgName] = useState('');
    const [org_size, setOrgSize] = useState('');
    const [org_sector, setOrgSector] = useState('');
    const [org_url, setOrgUrl] = useState('');
    const [org_address, setOrgAddress] = useState('');
    const [org_city, setOrgCity] = useState('');
    const [org_state, setOrgState] = useState('');
    const [org_pincode, setOrgPincode] = useState('');
    const [contact_name, setContactName] = useState('');
    const [contact_email, setContactEmail] = useState('');
    const [contact_mobile, setContactMobile] = useState('');
    const [contact_designation, setContactDesignation] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');

    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [selectedOrgSize, setSelectedOrgSize] = useState('');
    const [selectedSector, setSelectedSector] = useState('');
    const [photo, setPhoto] = useState('');
    const [selectedFile, setSelectedFile] = useState();
    const [file, setFile] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const [citiesList, setCitiesList] = useState([]);
    const [selectedShowCity, setSelectedShowCity] = useState('');
    const [isFetchingCities, setIsFetchingCities] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');


    useEffect(() => {
        handleCity();
        const orgData = location.state?.orgData;
        if (orgData) {
            setOrgName(orgData.org_name || '');
            setSelectedOrgSize(orgData.org_size || '');
            setSelectedSector(orgData.org_sector || '');
            setOrgUrl(orgData.org_url || '');
            setOrgAddress(orgData.org_address || '');
            setSelectedCity(orgData.org_city || '');
            setSelectedShowCity([{ value: orgData.org_city, label: orgData.org_city, state: orgData.org_state  }]);
            setSelectedState(orgData.org_state || '');
            setOrgPincode(orgData.org_pincode || '');
            setContactName(orgData.contact_name || '');
            setContactEmail(orgData.contact_email || '');
            setContactMobile(orgData.contact_mobile || '');
            setContactDesignation(orgData.contact_designation || '');
            setFile(orgData.org_image || ''); // Assuming image URL is provided
        }
    }, []);

    const handleCity = (searchQuery) => {
        setIsFetchingCities(true);
        const token = apiService.getAuthToken();
        apiService.get(`get-cities?city=${searchQuery || ''}`, token)      
        .then((response) => {
            const transformedCities = response.data.map(city => ({
                label: city.name,
                value: city.name,
                state: city.state_name
              }));
              setCitiesList(transformedCities);
        })
        .catch((e) => {
            console.log(e);
        })
        .finally(()=> {
            setIsFetchingCities(false);
        })
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        handleCity(searchQuery);
      }, [searchQuery]);
    
      const handleInputChange = (event, {action}) => {
        const searchTerm = event;
        // Fetch cities only when the search query length is greater than or equal to 3 characters
        if (searchTerm?.length >= 3) {
            setSearchQuery(searchTerm);
        }
    };

    const handleCityChange = (selectedOption) => {
        console.log("selectedOption",selectedOption);
        setSelectedShowCity(selectedOption);
        setSelectedCity(selectedOption.value);
        setSelectedState(selectedOption.state);
    };


    const orgSizeOptions = [
        { value: '0 - 10', label: '0 - 10' },
        { value: '11 - 100', label: '11 - 100' },
        { value: '101 - 500', label: '101 - 500' },
        { value: '501 - 1000', label: '501 - 1000' },
        { value: '1000+', label: '1000+' },
    ];

    const sectorOptions = [
        { value: 'Agriculture', label: 'Agriculture' },
        { value: 'Automotive', label: 'Automotive' },
        { value: 'Banking', label: 'Banking' },
        { value: 'Biotechnology', label: 'Biotechnology' },
        { value: 'Chemicals', label: 'Chemicals' },
        { value: 'Construction', label: 'Construction' },

        { value: 'Consulting', label: 'Consulting' },
        { value: 'Consumer Goods', label: 'Consumer Goods' },
        { value: 'Education', label: 'Education' },
        { value: 'Energy', label: 'Energy' },
        { value: 'Engineering', label: 'Engineering' },
        { value: 'Entertainment', label: 'Entertainment' },

        { value: 'Environmental', label: 'Environmental' },
        { value: 'Fashion', label: 'Fashion' },
        { value: 'Finance', label: 'Finance' },
        { value: 'Food & Beverage', label: 'Food & Beverage' },
        { value: 'Government', label: 'Government' },
        { value: 'Healthcare', label: 'Healthcare' },

        { value: 'Hospitality', label: 'Hospitality' },
        { value: 'Information Technology (IT)', label: 'Information Technology (IT)' },
        { value: 'Insurance', label: 'Insurance' },
        { value: 'Legal', label: 'Legal' },
        { value: 'Manufacturing', label: 'Manufacturing' },
        { value: 'Marketing & Advertising', label: 'Marketing & Advertising' },

        { value: 'Media', label: 'Media' },
        { value: 'Nonprofit', label: 'Nonprofit' },
        { value: 'Pharmaceuticals', label: 'Pharmaceuticals' },
        { value: 'Real Estate', label: 'Real Estate' },
        { value: 'Retail', label: 'Retail' },
        { value: 'Telecommunications', label: 'Telecommunications' },

        { value: 'Transportation', label: 'Transportation' },
        { value: 'Travel & Tourism', label: 'Travel & Tourism' },
        { value: 'Utilities', label: 'Utilities' },
        { value: 'Other', label: 'Other' },
    ];

    const handleOrgSizeChange = (value) => {
        setSelectedOrgSize(value);
    }

    const handleSectorChange = (value) => {
        setSelectedSector(value);
    }

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setContactEmail(newEmail);
        validateEmail(newEmail);
    };

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailPattern.test(email);
        if (!isValid) {
            setEmailError('Please enter a valid email address.');
        } else {
            setEmailError('');
        }
    };

    const handlePhoneChange = (e) => {
        const newPhoneNumber = e.target.value;
        setContactMobile(newPhoneNumber);
        validatePhone(newPhoneNumber);
    };

    const validatePhone = (phone) => {
        const phonePattern = /^[0-9]{10}$/;
        const isValid = phonePattern.test(phone);
        if (!isValid) {
            setPhoneError('Please enter a valid 10-digit phone number.');
        } else {
            setPhoneError('');
        }
    };

    const handleImageChange = (e) => {
        
        setSelectedFile(e.target.files[0]);
        const selectedImage = e.target.files[0];
        const allowedTypes = ['image/png','image/jpg','image/jpeg','image/svg+xml'];

        if(selectedImage && allowedTypes.includes(selectedImage.type)){
            setFile(URL.createObjectURL(selectedImage))
            
        }else{
            CustomToast.error('Please select a PNG, JPG, SVG or JPEG file.');
        }

    };

    const handleClose = () => {
        navigate('/organisation_admin')
    };

    const handleSend = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append("org_name", org_name);
        formData.append("org_size", selectedOrgSize);
        formData.append("org_sector", selectedSector);
        formData.append("org_url", org_url);
        formData.append("org_address", org_address);
        formData.append("org_city", selectedCity);
        formData.append("org_state", selectedState);
        formData.append("org_pincode", org_pincode);
        formData.append("contact_name", contact_name);
        formData.append("contact_email", contact_email);
        formData.append("contact_mobile", contact_mobile);
        formData.append("contact_designation", contact_designation);

        if (selectedFile) {
            formData.append("image", selectedFile, selectedFile.name);
        }
        const token = apiService.getAuthToken()
        const orgId = orgData?.org_id || localStorage.getItem("ORGID")
        apiService.patchV1(`update-org/${orgId}`, formData, token)
            .then((response) => {
                CustomToast.success('Organization updated successfully')
                navigate(`/organisation_admin`)
            })
            .catch((e) => {
                console.log(e);
                CustomToast.error('Error while updating organization')
            });

    }

    return (
        <div className='nosidebar-page__main'>
            <div className="dashboard">

                <div className='profile-form-wrapper m-auto'>
                    <h3 className='font-weight-600 font-20'>Edit Org.</h3>
                    <div className="card p-lg-3 p-0">
                        <div className="card-body">

                            <form onSubmit={handleSend}>
                                { /*<div className='row'>
                                    <img src={file} className='w-25 h-25 mx-auto custom-image-upload org mb-4'/>
                                </div>
                                <div className='row' >
                                    <div className="form-group w-100 text-center mb-4">
                                        <a className='img_upload fw-bold'>Change Image
                                        <input
                                                accept="image/*"
                                                name="file"
                                                type="file"
                                                onChange={handleImageChange}
                                                // style={{ display: 'none' }} 
                                            />
                                        </a>                                     
                                    </div>
                                    </div>*/}

                                <div className="form-group w-100 text-start mb-5">
                                    <label className='custom-image-upload org'>
                                        <div className='d-flex justify-content-center align-items-center h-100 m-auto' style={{maxHeight: '200px', maxWidth: '200px'}}>
                                            <img src={file} className='w-100' style={{maxHeight: '200px', maxWidth: '200px', objectFit: 'contain'}} />
                                        </div>
                                        <a className='img_upload d-none'>Change Image
                                            <input
                                                accept="image/*"
                                                name="file"
                                                type="file"
                                                onChange={handleImageChange}
                                                style={{ display: 'none' }}
                                            />

                                        </a>
                                    </label>
                                </div>
                                <h5 className='fw-bold pt-4 mb-4'>Basic Information</h5>
                                <div className='row mt-4 mb-4'>
                                    <div className="col-lg-6 form-group mb-3">
                                        <label className='mb-2'>Org. Name*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Organisation Name'
                                            value={org_name}
                                            name="org_name"
                                            onChange={(event) => setOrgName(event.target.value)}
                                            required />
                                    </div>
                                    <div className="col-lg-6 form-group mb-3">
                                        <label className='mb-2'>Org. Size*</label>
                                        <CustomSelect
                                            id="orgSizeSelect"
                                            name="selectedOrgSize"
                                            placeholder="Select"
                                            value={selectedOrgSize}
                                            options={orgSizeOptions}
                                            onChange={handleOrgSizeChange}>
                                        </CustomSelect>
                                    </div>
                                    <div className='col-lg-6 form-group mb-3'>
                                        <label className='mb-2'>Sector / Industry*</label>
                                        <CustomSelect
                                            id="sectorSelect"
                                            name="selectedSector"
                                            placeholder="Select"
                                            value={selectedSector}
                                            options={sectorOptions}
                                            onChange={handleSectorChange}>
                                        </CustomSelect>
                                    </div>
                                    <div className='col-lg-6 form-group mb-3'>
                                        <label className='mb-2'>Org. website*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Organisation website'
                                            value={org_url}
                                            name="org_url"
                                            onChange={(e) => setOrgUrl(e.target.value)}
                                            required />
                                    </div>
                                </div>

                                <h5 className='fw-bold mb-4'>Org. Address</h5>
                                <div className='row mb-4'>
                                    <div className="col-lg-6 form-group mb-3">
                                        <label htmlFor="citySelect" className='mb-2'>Org. Address*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Organisation Address'
                                            value={org_address}
                                            name="org_address"
                                            onChange={(e) => setOrgAddress(e.target.value)}
                                            required />

                                    </div>

                                    <div className="col-lg-6 form-group mb-3">
                                        <label htmlFor="citySelect" className='mb-2'>City*</label>
                                        {/* <CustomSelect
                                            id="selectedCity"
                                            name="selectedCity"
                                            placeholder="Select"
                                            value={selectedCity}
                                            options={cityOptions}
                                            onChange={handleCityChange}>
                                            </CustomSelect> */}

                                            {/*<input
                                                type="text"
                                                className="form-control"
                                                placeholder='City'
                                                value={selectedCity}
                                                onChange={(event) => setSelectedCity(event.target.value)}
                                                required
                                        />*/}

                                            <Select
                                                options={citiesList}
                                                value={selectedShowCity}
                                                onInputChange={handleInputChange} // Add onInputChange handler
                                                isLoading={isFetchingCities}
                                                onChange={handleCityChange}
                                      
                                            />

                                    </div>

                                    <div className="col-lg-6 form-group mb-3">
                                        <label htmlFor="stateSelect" className='mb-2'>State*</label>
                                        {/*<CustomSelect
                                                id="selectedState"
                                                name="selectedState"
                                                placeholder="Select"
                                                value={selectedState}
                                                options={stateOptions}
                                                onChange={handleStateChange}>
                                                </CustomSelect>*/}

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='State'
                                            value={selectedState}
                                            onChange={(event) => setSelectedState(event.target.value)}
                                            required
                                            readOnly
                                        />
                                    </div>

                                    <div className="col-lg-6 form-group mb-3">
                                        <label className='mb-2'>Postal Code*</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder='xxx xxx'
                                            value={org_pincode}
                                            name="org_pincode"
                                            onChange={(e) => setOrgPincode(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center mt-4'>
                                    <button type='button' onClick={handleClose} className='btn btn-md btn-secondary w-100 me-2'>Cancel</button>
                                    <button className="btn btn-md btn-primary w-100 ms-3" type="submit">Save</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditOrganisationProfile;